import React from 'react';

import CommonQuantityPicker from '@common/components/QuantityPicker';
import { QuantityPickerWrapper, QuantityPickerLabel } from './QuantityPicker.styles';

type QuantityPickerProps = {
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  maxValue?: number;
  isDisabled?: boolean;
};

export const QuantityPicker: React.FC<QuantityPickerProps> = ({
  value,
  onChange,
  placeholder,
  maxValue,
  isDisabled,
  ...props
}) => (
  <QuantityPickerWrapper>
    <QuantityPickerLabel>{placeholder}</QuantityPickerLabel>
    <CommonQuantityPicker
      {...props}
      input={{ value, onChange }}
      maxValue={maxValue}
      isDisabled={isDisabled}
    />
  </QuantityPickerWrapper>
);
